import { InputBase } from '@mui/material'

import { withStyles } from 'tss-react/mui'

const CustomInput = withStyles(InputBase, (theme) => ({
  input: {
    position: 'relative',
    backgroundColor: theme.backgrounds.cardBackground,
    border: '1px solid transparent',
    '&:focus': {
      backgroundColor: theme.backgrounds.cardBackground,
    },
  },
}))

export default CustomInput
